import { Link } from 'react-router-dom'

export function NotFoundPage() {
	return (
		<div className="min-h-screen flex items-center justify-center bg-muted">
			<div className="text-center">
				<h1 className="text-6xl font-bold text-foreground">404</h1>
				<p className="mt-4 text-xl text-muted-foreground">Page not found</p>
				<Link to="/" className="mt-6 inline-block px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700">
					Go Home
				</Link>
			</div>
		</div>
	)
}
